import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-script",
  "use": "tamr-icon-script-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"tamr-icon-script\">\n  <circle cx=\"12.5\" cy=\"12.5\" r=\"12.5\" />\n  <path d=\"M9.9 17.1l-4.6-4.6 4.6-4.6-1.4-1.4-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6 1.4-1.4 6 6-6 6-1.4-1.4z\" fill=\"#FFF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol